import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';

import { withAiDescription } from '../../../../../components-shared/Settings/withAiDescription';

export const CART_BEHAVIOR = {
  SIDE_CART: 0,
  FULL_PAGE: 1,
} as const;

export type SettingsTabParams = {
  cartBehavior: SettingsParamType.Number;
};

/**
 * `metadata` exposes `cartBehavior` in the widget's editor manifest
 * (`editorElement.data`), which is what Aria reads and edits in Studio 2.
 * The OnlineOrders controller reads the stored value from public data.
 */
export const settingsTabParams = createSettingsParams<SettingsTabParams>({
  cartBehavior: {
    type: SettingsParamType.Number,
    getDefaultValue: () => CART_BEHAVIOR.SIDE_CART,
    metadata: ({ t }) => ({
      type: DataType.number,
      defaultValue: { type: 'static', value: CART_BEHAVIOR.SIDE_CART },
      ...withAiDescription({
        displayName: t('app.settings.settings.order-button'),
        description:
          'What the View Order button opens: 0 = side cart (default), 1 = full cart page. ' +
          'Mobile, and sites without a side cart, always open the full cart page. ' +
          'The button appears only after a customer adds an item to the cart.',
      }),
    }),
  },
});
